import apiClient from "@/services/apiClient";
import type { SingleUserResponse } from "@/types/user";



export const userService = {
  /**
   * Fetch current user from token
   */
  async fetchCurrentUser(): Promise<SingleUserResponse> {
    const response = await apiClient.get("/v1/users/me");
    return response.data;
  },

}; 